import React from 'react';
import {Spin} from "antd";
import { LoadingOutlined } from '@ant-design/icons';

const antIcon = <LoadingOutlined style={{ fontSize: 40, textAlign: 'center' }} spin />;

const Loading = () => {
    return (
        <div className="loading-page">
            <div className="loading-icon">
                <Spin indicator={antIcon} tip="Loading..." size="large"/>
            </div>
        </div>
    );
};

export default Loading;